import {
  Button,
  Divider,
  IconButton,
  Stack,
  createStyles,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import LinkIcon from "@mui/icons-material/Link";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddIcon from "@mui/icons-material/Add";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import React, { useEffect, useState } from "react";
import { black } from "../../utils/StyleHelpers";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";

const buttonStyle = createStyles({
  color: black,
  textTransform: "none",
});

const ContextMenu = (props: any) => {
  const selectedThumbnails = useContentStore(
    (state: any) => state.selectedThumbnails,
  );
  const setSelectedThumbnails = useContentStore(
    (state: any) => state.setSelectedThumbnails,
  );
  const setIsShowDeleteDialog = useContentStore(
    (state: any) => state.setIsShowDeleteDialog,
  );
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );
  const [isMultiple, setIsMultiple] = useState(false);

  useEffect(() => {
    setIsMultiple(selectedThumbnails.length > 1);
  }, [selectedThumbnails]);

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      flexWrap={"wrap"}
      divider={<Divider orientation="vertical" flexItem />}
      style={{
        background: "#F0F4F8",
        borderRadius: "0.5rem",
        padding: "0.25rem",
        gap: "2.5rem",
        alignItems: "center",
        marginBottom: "2.5rem",
        marginTop: "1rem",
        visibility: props?.isShow || props?.isShowPlayer ? "visible" : "hidden",
      }}
      justifyContent={props?.isShowPlayer ? "center" : ""}
    >
      {props?.isShowPlayer ? (
        ""
      ) : (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          flexWrap={"wrap"}
          spacing={3}
        >
          <Stack direction="row">
            <IconButton
              aria-label="clear"
              onClick={() => setSelectedThumbnails([])}
            >
              <ClearIcon />
            </IconButton>
            <Button variant="text" disabled={true} style={buttonStyle}>
              {`${selectedThumbnails.length} ${locale.control_selected}`}
            </Button>
          </Stack>
          {!isMultiple && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<PlayCircleOutlineIcon fontSize="small" />}
              onClick={props.onClickPlay}
            >
              {locale.control_play}
            </Button>
          )}
        </Stack>
      )}

      <Stack
        direction={{ xs: "column", sm: "row" }}
        flexWrap={"wrap"}
        spacing={2}
      >
        {!isMultiple && (
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<LinkIcon fontSize="small" />}
            onClick={props.onCopyLinks}
          >
            {locale.control_copy}
          </Button>
        )}
        <Button
          variant="text"
          style={buttonStyle}
          startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
          onClick={props.onDownload}
        >
          {locale.control_download}
        </Button>
        {props.isShowDetails ? (
          <></>
        ) : (
          !isMultiple && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<InfoOutlinedIcon fontSize="small" />}
              onClick={props.onClickDetails}
            >
              {locale.control_details}
            </Button>
          )
        )}
      </Stack>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        flexWrap={"wrap"}
        spacing={2}
      >
        {!props?.isShowDetails && (
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<DriveFileMoveOutlinedIcon fontSize="small" />}
            onClick={props.onClickMove}
            sx={{
              ":disabled": {
                opacity: "0.5",
              },
            }}
            disabled={!rolePermissions?.video?.move}
          >
            {locale.control_move}
          </Button>
        )}
        {!isMultiple && (
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<DriveFileRenameOutlineOutlinedIcon fontSize="small" />}
            onClick={props.onClickRename}
            sx={{
              ":disabled": {
                opacity: "0.5",
              },
            }}
          >
            {locale.control_rename}
          </Button>
        )}
        <Button
          variant="text"
          style={buttonStyle}
          startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
          onClick={() => setIsShowDeleteDialog(true)}
        >
          {locale.control_delete}
        </Button>
      </Stack>
      {!props?.isShowDetails && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          flexWrap={"wrap"}
          spacing={2}
        >
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<AddIcon fontSize="small" />}
            onClick={props.onClickRetag}
            sx={{
              ":disabled": {
                opacity: "0.5",
              },
            }}
          >
            {locale.add_tag}
          </Button>
          {!isMultiple && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<IosShareOutlinedIcon fontSize="small" />}
              onClick={props.onClickExport}
              sx={{
                ":disabled": {
                  opacity: "0.5",
                },
              }}
            >
              {locale.exportTranscript}
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default ContextMenu;
